// extracted by mini-css-extract-plugin
export default {"previewImage":"previewImage__JAxLN","table":"table__qEMBP","tableActions":"tableActions__iPfpG"};